import { render } from "./account-manager.vue?vue&type=template&id=18231de4&ts=true"
import script from "./account-manager.ts?vue&type=script&lang=ts&external"
export * from "./account-manager.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__